import type { FacilitatorLiveSessionCard } from '../../../../../../pure-js/types/FacilitatorLiveSessionMonitor'
import { useFacilitatorGameCallLink } from '../../../../apiLayer/queryHooks/mutations'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { useOpenCallInNewTab } from './useOpenCallInNewTab'

/** Opens a game card's team call in a new tab. */
export const useJoinTeamCall = () => {
  const { t } = useTranslation()
  const callLink = useFacilitatorGameCallLink()
  const callTab = useOpenCallInNewTab()

  const join = (card: FacilitatorLiveSessionCard) => {
    const request = { sprintId: card.sprintId, activityId: card.activityId, teamId: card.teamId }
    const openedMessage = t(
      'facilitator.controlTower.joinCallOpened',
      'Call opened in a new tab — leave it when the team finishes so their analysis can start.'
    )

    callTab.openWhenLinked((callbacks) => callLink.mutate(request, callbacks), openedMessage)
  }

  return { join, isOpening: callLink.isPending, outcome: callTab.outcome, clearOutcome: callTab.clearOutcome }
}
